import { Action } from 'redux';
import { StopSellFilters, StopSellModel } from '../../../api/pricing/pricing.types';
import { Page } from '../../../api/api.types';

export const GET_STOP_SELL_LIST = 'GET_STOP_SELL_LIST';
export const GET_STOP_SELL = 'GET_STOP_SELL';
export const PUT_STOP_SELL = 'PUT_STOP_SELL';
export const POST_STOP_SELL = 'POST_STOP_SELL';
export const DELETE_STOP_SELL = 'DELETE_STOP_SELL';
export const UPDATE_STOP_SELL_FILTERS = 'UPDATE_STOP_SELL_FILTERS';

export interface StopSellState {
  stopSells: StopSellModel[] | [];
  selectStopSell: StopSellModel | null;
  postSuccess: boolean | null;
  lastFetch: number | null;
  totalPages: number;
  totalElements: number;
  filters: StopSellFilters | null;
}

export interface GetStopSellListAction extends Action {
  type: typeof GET_STOP_SELL_LIST;
  payload: {
    page: Page<StopSellModel>;
  };
}

export interface GetStopSellAction extends Action {
  type: typeof GET_STOP_SELL;
  payload: {
    selectedStopSell: StopSellModel | null;
  };
}

export interface PutStopSellAction extends Action {
  type: typeof PUT_STOP_SELL;
  payload: {
    selectedStopSell: StopSellModel;
  };
}

export interface PostStopSellAction extends Action {
  type: typeof POST_STOP_SELL;
  payload: {
    newStopSell: StopSellModel;
    success: boolean;
  };
}

export interface DeleteStopSellAction extends Action {
  type: typeof DELETE_STOP_SELL;
  payload: {
    success: boolean;
  };
}

export interface UpdateStopSellFilters extends Action {
  type: typeof UPDATE_STOP_SELL_FILTERS;
  payload: {
    filters: StopSellFilters;
  };
}

export type StopSellActionTypes = GetStopSellListAction | GetStopSellAction | PutStopSellAction | PostStopSellAction | DeleteStopSellAction | UpdateStopSellFilters;
